module.exports = __webpack_public_path__ + "img/gmo-sp.62c691fa.png";